var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ready"},[_c('TestvIntro',{staticClass:"comp__TestvIntro"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }